module.exports = __webpack_public_path__ + "static/media/comment-edit.d62af594.svg";